(function () {
  'use strict';

  angular
    .module('gunta', [
      // 'ngAnimate',
      'ngCookies',
      'monospaced.elastic',
      'ngTouch',
      'ngSanitize',
      'ngAria',
      'ui.router',
      'ui.router.state.events',
      'ui.bootstrap',
      'ngLodash',
      'angular-scroll-animate',
      'duScroll',
      'toastr',
      'angular.backtop',
      'chart.js'
    ])

})();

(function () {
  'use strict';

  /**
   * Voici un exemple de question avec un type radio :
   *  {
           "id": 1,
           "category": 1,
           "ref": "1.1.1.1",
           "name": "Besoins en lien avec les fonctions du cerveau (fonctions mentales dont cognitives et psychiques) incluant : Fonctions de la conscience, Fonctions psychosociales globales, Fonctions de l'énergie et des pulsions (ex : les besoins en lien avec les comportements inappropriés type désinhibition, ...), Fonctions du sommeil",
           "type": "radio",
           "callback_variable": "",
           "comment": true,
           "responses": [{
             "id": 1,
             "score": "N",
             "value": "N",
             "name": "Non concerné"
           }, {
             "id": 2,
             "score": 0,
             "value": "A",
             "name": "Autonomie totale : l’usager peut réaliser l’activité ou y participer totalement seul, sans aide"
           }, {
             "id": 3,
             "score": 1,
             "value": "B",
             "name": "L’usager peut réaliser l’activité ou y participer de façon majoritairement seul, mais a besoin d’une aide pour l’accomplir (la part de cette aide est moindre que le degré d’autonomie)"
           }, {
             "id": 4,
             "score": 2,
             "value": "C",
             "name": "L’usager peut réaliser l’activité ou y participer avec une part d’autonomie, mais doit être majoritairement accompagné."
           }, {
             "id": 5,
             "score": 3,
             "value": "D",
             "name": "Dépendance totale = besoin total. L’usager ne peut pas du tout réaliser l’ activité seul ou y participer seul.A besoin d’ être intégralement accompagné ou aidé."
           }]
        }
   **/


  angular
    .module('gunta')

  /**
   * Directive
   */

  .directive('surveyQuestion', surveyQuestionDirective);


  function surveyQuestionDirective($window, lodash, $timeout, $document, $sce, ApplyService) {

    var directive = {
      restrict: 'E',
      scope: {
        question: '=?',
        survey: '=?',
        resource: '=?',
      },
      controller: controllerFunc,
      controllerAs: 'surveyQuestion',
      templateUrl: 'app/components/surveyQuestion/surveyQuestion.template.html',
      link: linkFunc
    };

    return directive;

    /**
     * Link function
     * @method linkFunc
     * @return {}
     */

    function linkFunc($scope, element, attrs, surveyQuestion) {
      // Récolte des informations au sujet de la question.
      surveyQuestion.question = $scope.question;
      surveyQuestion.survey = $scope.survey;
      surveyQuestion.resource = $scope.resource;
      // référence unique de la question
      surveyQuestion.ref = ApplyService.getCallbackVariableOfQuestion(surveyQuestion.question);


      /**
       * Comentaire
       */

      surveyQuestion.comment = {
        enabled: lodash.get(surveyQuestion.question, 'comment', false),
        activeButton: false,
        activeForm: false,
        canUpdate: lodash.get(surveyQuestion.resource, '_responseState', null) === 'done' ? false : true,
        value: lodash.get(surveyQuestion.question, '_comment', null),
      }


      /**
       * Traitement des helps.
       */

      surveyQuestion.question = surveyQuestion.help(surveyQuestion.question);


      /**
       *
       * Sélectionner une réponse à une question de type "radio".
       * @method doCheck
       * @param  {Object} answer  Réponse sélectionnée
       * @return {}
       */

      surveyQuestion.doAnswerWithRadioType = function (answer) {

        if (surveyQuestion.resource._responseState === 'done') {
          return false;
        }

        // Les autres questions sont passés en checked false.
        lodash.forEach(surveyQuestion.question.responses, function (response) {
          if (response.id !== answer.id) {
            response._checked = false;
          } else {
            response._checked = true;
          }
        })

        // Sauvegarde d'une question.
        ApplyService.saveAnswer(surveyQuestion.question, answer, surveyQuestion.survey, surveyQuestion.resource);

        // Activiation du bouton "Ajouter commentaire"
        // S'il y a "comment" : true.
        if (surveyQuestion.comment.enabled) {
          surveyQuestion.comment.activeButton = true;
        }

        surveyQuestion.whenQuestionDone(false);
      }



      /**
       * Cette fonction rend actif le formulaire pour écrire un commentaire.
       * @method showCommentForm
       */

      surveyQuestion.toggleCommentForm = function () {
        surveyQuestion.comment.activeForm = !surveyQuestion.comment.activeForm;
      }

      /**
       * Ajouter un commentaire depus le bouton ajouter.
       * @method addComment
       */

      surveyQuestion.addComment = function (comment) {
        surveyQuestion.toggleCommentForm();
        // Copy du commentaire.
        var _comment = angular.copy(comment);
        // Ajout du commentaire dans la question.
        surveyQuestion.question._comment = _comment;
        // Sauvegarde du commetaire d'une question.
        ApplyService.saveAnswerComment(surveyQuestion.question, surveyQuestion.survey, surveyQuestion.resource);

        surveyQuestion.whenQuestionDone(true);
      }


      /**
       * Lorsqu'on a donné une réponse à une question.
       * @method whenQuestionDone
       * @return {[type]}
       */

      surveyQuestion.whenQuestionDone = function (doScrolling) {
        // On indique que la question est done.
        surveyQuestion.question._done = true;

        if (doScrolling) {
          // Hauteur du block.
          var elementOffsetHeight = element.prop('offsetHeight');
          // Position par rapport au haut de la page
          var elementOffsetTop = element.prop('offsetTop');

          // On Scroll jusqu'à la prochaine question une fois qu'on a validé notre réponse.
          $timeout(function () {
            $document.scrollTop((elementOffsetTop + elementOffsetHeight), 750);
          });
        }


        if (attrs.whenQuestionDone) {
          $scope.$parent.$eval(attrs.whenQuestionDone);
        }
      }
    }

    /**
     * Controller func
     * @method controllerFunc
     * @return {}
     */

    function controllerFunc() {
      var vm = this;

      /**
       * Animation IN
       * @method animateElementIn
       */

      vm.animateElementIn = function ($el) {
        $el.removeClass('not-visible');
      };

      /**
       * Animation OUT
       * @method animateElementOut
       */

      vm.animateElementOut = function ($el) {
        $el.addClass('not-visible');
      };


      /**
       * Cette méthode s'occupe de gérer le help pour la question.
       * Ce help peut être récupéré dans les réponses/
       * @method help
       * @param  {Object} question
       * @return {}
       */

      vm.help = function (question) {
        // Si la question possède déja un help.
        if (!lodash.isEmpty(question.help)) {
          return question;
        }

        var help = '';

        // SI c'est un type radio.
        // Il faut boucler sur les répnses.
        if (question.type === 'radio') {

          lodash.forEach(question.responses, function (response) {
            if (lodash.isEmpty(response.help)) {
              return;
            }
            help += '<b>' + response.value + '</b> : ' + response.help + '<br>';
          });
        }
        // assignation du help
        question.help = $sce.trustAsHtml(help);
        // gestion du help pour les types radios.
        return question;
      }

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .filter("nl2br", function () {
      return function (data) {

        if (!data) {
          return data;
        }

        return data.replace(/\n\r?/g, '<br/>');

      };
    });
})();

(function () {
  'use strict';

  angular
    .module('gunta')

    /**
     * Directive
     */

    .directive('navbar', navbar);


  function navbar($window, $state, ApplyService, lodash, toastr) {

    var directive = {
      restrict: 'E',
      scope: true,
      controllerAs: '$ctrl',
      bindToController: {
        resource: '=?',
        survey: '=?',
        sendApply: '&?',
        sendApplyButtonDisabled: '=?',
      },
      templateUrl: 'app/components/navbar/navbar.template.html',
      controller: controllerFunc,
      link: linkFunc
    };

    return directive;

    /**
     * Link function
     * @method linkFunc
     * @return {}
     */

    function linkFunc() {

    }


    /**
     * Controller func
     * @method controllerFunc
     * @return {}
     */

    function controllerFunc($scope) {
      var vm = this;

      vm.isApply = lodash.isUndefined(vm.sendApply) ? false : true;

      /**
       * Resume later.
       */

      vm.resumeLater = function () {
        $state.go('app.survey');
      }

      // /**
      //  * Envoyer la réponse.
      //  * @method sendApply
      //  */

      vm.sendingProgress = false;

      vm.doSendButton = function () {

        vm.sendingProgress = true;

        $scope.$eval(vm.sendApply);
      }

      // /**
      //  * print function
      //  * @method print
      //  * @return {}
      //  */

      vm.print = function () {
        $window.print();
      }

      // /**
      //  * Générer les statistiques d'un
      //  * @method statistics
      //  * @return {[type]}
      //  */

      vm.doChartStatistics = function () {

        $state.go('app.chart', {
          "resourceId": vm.resource.id,
          "surveyId": vm.survey.id,
        })

      }

      /**
       * DO Eval.
       * @method doSurveyForResource
       * @return {[type]}
       */

      vm.doSurveyForResource = function () {

        $state.go('app.apply', {
          "resourceId": vm.resource.id,
          "surveyId": vm.survey.id,
        });

      }


    }

  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .directive('ngSrc404', function () {

      return {
        restrict: 'A',
        link: function (scope, element, attrs) {

          element.bind('error', function () {
            if (attrs.src !== attrs.ngSrc404) {
              attrs.$set('src', attrs.ngSrc404);
            }
          });

        }
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .directive('loader', loader);

  /** @ngInject */
  function loader() {

    var directive = {
      restrict: 'E',
      template: '<div class="loader-container animated fadeIn" ng-if="isVisible"><div class="loader"><div class="loader__bar"></div><div class="loader__bar"></div><div class="loader__bar"></div><div class="loader__bar"></div><div class="loader__bar"></div><div class="loader__ball"></div></div></div>',
      link: linkFunc
    };

    return directive;

    function linkFunc($scope) {

      $scope.isVisible = false;

      $scope.$on('$stateChangeStart', function () {
        $scope.isVisible = true;
      });

      $scope.$on('$stateChangeSuccess', function () {
        $scope.isVisible = false;
      });

      $scope.$on('$stateChangeError', function () {
        $scope.isVisible = false;
      });

    }


  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .directive('autofocus', autofocus)

  function autofocus($timeout) {

    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc($scope, element) {
      $timeout(function () {
        element[0].focus();
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .factory('UserService', UserService)

  function UserService($q, $http, $window, SurveyService, $state, $stateParams, lodash, API, StoreService) {

    return {

      /**
       * Définis si l'utilisateur a une session active.
       * Cette session est activée lorsque on est connecté.
       * @method hasSession
       * @return {Boolean}
       */

      hasSession: function () {

        var session = StoreService.get("user");

        if (lodash.isEmpty(session)) {
          return false;
        }

        return true;
      },


      /**
       * Récupération d'une session (token)
       * @method getSession
       * @return {string}
       */

      getSession: function (key) {
        return StoreService.get("user", key);
      },

      /**
       * Retour du token.
       * @method getToken
       * @return {string}
       */

      getToken: function () {
        var token = this.getSession('token');
        // return token
        return token;
      },

      /**
       * Méthode d'authentification.
       * @method auth
       */

      auth: function (credentials) {

        var defer = $q.defer();

        var request = $http({
          url: API + '/user/login',
          method: 'POST',
          data: credentials
        })

        sessionStorage.clear();

        request
          .then(
            function success(responseSuccess) {
              // Store Token
              if (responseSuccess.status === 200) {
                // Création du store.
                StoreService.add("user", {
                  "token": responseSuccess.data
                });
                defer.resolve();
              }
            },
            function fail(responseError) {
              defer.reject(responseError.data);
            })

        return defer.promise;
      },

      /**
       * Méthode de déconnexion.
       * @method logout
       * @return {[type]}
       */

      logout: function () {

        var defer = $q.defer();
        // var self = this;

        var request = $http({
          url: API + '/user/logout',
          method: 'POST'
        })

        request
          .then(
            function success() {
              sessionStorage.clear();
              SurveyService.deleteSurveys();
              defer.resolve();
            },
            function fail() {
              defer.reject();
            })

        return defer.promise;
      }


    }
  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .factory('SurveyService', SurveyService);


  function SurveyService(StoreService, $http, $q, lodash, API) {

    var surveys = null;

    return {

      updateSurvey: function (_survey, _resource) {

        var surveyIndex = lodash.findIndex(surveys, {
          "id": _survey.id
        });
        var resourceIndex = lodash.findIndex(surveys[surveyIndex].resources, {
          "id": _resource.id
        });
        surveys[surveyIndex].resources[resourceIndex] = _resource;
      },

      /**
       * Méthode permettant de calculer les statistiques des surveys et leurs ressources
       * @method _statisticsCalculation
       * @param  {array}  surveys
       * @return {array}  surveys
       */

      _statisticsCalculation: function (surveys) {
        // boucle sur les surveys
        lodash.forEach(surveys, function (survey) {
          // totalisation des questions.
          survey._numberOfQuestions = survey.questions.length;
          // hasOneSurveyFinished
          survey._hasOneSurveyFinished = false;
          // boucle sur les resources du survey.
          var resourceQuestionsDone = 0;
          lodash.forEach(survey.resources, function (resource) {
            //FIXME : MODE UNIQUE.
            var resourceResponse = lodash.head(resource.responses);
            var _response = lodash.get(resourceResponse, 'response');
            // garde fou
            if (lodash.isString(_response)) {
              _response = angular.fromJson(_response);
            }

            // calcul de la taille du tableau
            resource._numberOfQuestionsDone = lodash.size(_response);
            // progression.
            resource._progression = (resource._numberOfQuestionsDone / survey._numberOfQuestions) * 100
            resourceQuestionsDone = (resourceQuestionsDone + resource._numberOfQuestionsDone);
            // la ressource a répondu au survey ?
            // FIXME UNIQUE MODE.
            resource._responseState = lodash.get(resourceResponse, 'state', null);
            if (resource._responseState === 'done') {
              // hasOneSurveyFinished
              survey._hasOneSurveyFinished = true;
            }
          });
          // progression.
          survey._progression = (resourceQuestionsDone / (survey._numberOfQuestions * survey.resources.length)) * 100

        });

        return surveys;
      },

      /**
       * Stockage des surveys.
       * @method
       */

      _surveys: function () {
        return this._statisticsCalculation(surveys);
      },

      deleteSurveys: function () {
        surveys = null;
      },

      /**
       * Récupération des Survey de de l'utilisateur connecté.
       * @method getSurveys
       * @return {array}
       */

      getSurveys: function () {
        var self = this;

        // Si on possède déjà des survey.
        // on met à jour les stats au passage.
        if (self._surveys()) {
          return self._surveys();
        }

        var defer = $q.defer();
        var request = $http({
          url: API + '/survey',
          method: 'GET',
        });

        request
          .then(
            function success(responseSuccess) {
              // Store Token
              if (responseSuccess.status === 200) {
                // Création du store.
                surveys = self._statisticsCalculation(responseSuccess.data);
                defer.resolve(surveys);
              }
            },
            function fail() {
              defer.reject();
            })

        return defer.promise;

      },

      /**
       * Récupérer un survey en fonction de son id.
       * @method getSurveyFromId
       * @param  {int}        id
       * @return {object}
       */

      getSurveyFromId: function (id) {
        var surveys = this.getSurveys();

        var survey = lodash.find(surveys, {
          "id": lodash.toInteger(id)
        });

        return survey;
      }

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .controller('SurveyController', SurveyController);

  function SurveyController($scope, surveys, $filter, $state, lodash, UserService) {
    var vm = this;

    /**
     * Surveys.
     * @type {}
     */

    vm.surveys = surveys;


    console.log(vm.surveys);

    /**
     * Ressource
     */

    vm.resources = [];
    // resources sur lesquels les filtres agissent.
    vm.parsedResources = [];

    /**
     * Resources pagination controls.
     * @type {Object}
     */

    vm.resourcesPagination = {
      currentPage: 1,
      total: 0,
      itemsPerPage: 10,
      numberOfPages: 0,
    }

    /**
     * Pagination resources controles.
     * @method resourcesPaginationControls
     * @param  {object}                    survey
     * @return {}
     */

    var resourcesPaginationControls = function (survey) {
      // affect resources.
      vm.resources = survey.resources;
      vm.parsedResources = angular.copy(vm.resources);
      // pagination.
      vm.resourcesPagination.total = vm.resources.length
      vm.resourcesPagination.numberOfPages = Math.ceil(vm.resourcesPagination.total / vm.resourcesPagination.itemsPerPage);
    }

    // S'il il n'y a qu'une seule campagne.
    if (surveys.length === 1) {
      resourcesPaginationControls(surveys[0]);
    }

    /**
     * Search field
     * @type {Object}
     */

    vm.search = {
      enabled: false,
      value: '',
      // eval ok.
      showDoneSurveyForResource: false,
      // en cours...
      showPendingSurveyForResource: false,
    }

    var lastPage = angular.copy(vm.resourcesPagination.currentPage);
    // listener sur les boutons et recherche.
    $scope.$watchGroup(['$ctrl.search.showDoneSurveyForResource', '$ctrl.search.showPendingSurveyForResource', '$ctrl.search.value'], function (newVal, oldVal) {
      if (oldVal === newVal) {
        return;
      }

      var items = angular.copy(vm.resources);
      var doFilter = false;

      if (vm.search.showDoneSurveyForResource === true) {
        items = lodash.filter(items, {
          "_responseState": "done"
        })
        doFilter = true;
      }

      if (vm.search.showPendingSurveyForResource === true) {
        items = lodash.filter(items, {
          "_responseState": "pending"
        });
        doFilter = true;
      }

      if (vm.search.value !== '') {
        items = $filter('filter')(items, {
          "name": vm.search.value
        });
      }

      if (doFilter) {
        lastPage = angular.copy(vm.resourcesPagination.currentPage);
      }

      // affectations des nouvelles ressources.
      vm.parsedResources = items;

      // pagination.
      vm.resourcesPagination.total = items.length;
      vm.resourcesPagination.numberOfPages = Math.ceil(vm.resourcesPagination.total / vm.resourcesPagination.itemsPerPage);

      // si page en mémoire.
      if (lastPage) {
        vm.resourcesPagination.currentPage = lastPage;
      }

    })

    /**
     * Selectionnez un survey pour afficher les personnes qui doivent être évalués à droite.
     * @method selectSurvey
     * @return {}
     */

    vm.selectSurvey = function (survey) {
      resourcesPaginationControls(survey);
    }

    /**
     * Selectionn d'une personne à évaluer.
     * @method selectApply
     * @param  {object}    resources
     */

    vm.selectResource = function (resource) {
      // State go.
      $state.go('app.apply', {
        "surveyId": lodash.get(resource, 'survey_id'),
        "resourceId": lodash.get(resource, 'id')
      });
    }

    vm.doChartForResource = function (resource) {
      $state.go('app.chart', {
        "resourceId": resource.id,
        "surveyId": resource.survey_id,
      })
    };

    vm.doChartForSurvey = function (survey) {
      $state.go('app.chart', {
        "surveyId": survey.id,
      })
    }

    /**
     * Connexion.
     * @method doLogout
     * @return {[type]}
     */

    vm.doLogout = function () {
      UserService
        .logout()
        .then(function () {
          $state.go('auth');
        })
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .factory('StoreService', StoreService);

  /**
   * SERVICE STORE
   */


  function StoreService(StoreConfiguration, $window, $log, lodash, $injector) {

    /**
     * Est ce que c'est un store en sessionStorage?
     * @type {bool}
     */

    var sessionStorage = StoreConfiguration.getType() === 'sessionStorage' ? true : false;

    return {

      /**
       * Retourne la nom préfixé d'un store.
       * Cette méthode éviter des confusions lorsqu'une même application utilise le  storage.
       * Par exemple une app stocke UsgBenef et l'autre app aussi, le  storage sera écrasé
       * @method _prefixStoreName
       * @param  {string}         name
       * @return {string}
       */

      _prefixStoreName: function (name) {
        return $injector.get('APP_STORAGE_PREFIX') + '_' + name;
      },

      /**
       * Enregistrement une donnée dans le store.
       * @method set
       * @param  {String} storeName Nom du store
       * @param  {any}    data Donnée à enregistrer
       **/

      set: function (storeName, data) {

        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        var self = this;
        // convert to json.
        _data = angular.toJson(_data);

        if (sessionStorage) {
          $window.sessionStorage[self._prefixStoreName(storeName)] = _data;
        } else {
          $window.localStorage[self._prefixStoreName(storeName)] = _data;
        }

      },

      /**
       * Récupérer les données d'un store passé en paramètre.
       * @method get
       * @param  {string} storeName Nom du store
       * @param  {any}    search    Recherche directement dans le store.
       * @return {any}
       */

      get: function (storeName, search) {

        var storedData;
        var self = this;

        // Récupération du store.
        if (sessionStorage) {
          storedData = $window.sessionStorage[self._prefixStoreName(storeName)];
        } else {
          storedData = $window.localStorage[self._prefixStoreName(storeName)];
        }

        // Si le store n'existe pas ou vide.
        if (lodash.isUndefined(storedData)) {
          return null;
        }
        // convert data.
        storedData = angular.fromJson(storedData);

        // Si on a défini une clé spécifique à récupérer.
        if (!lodash.isUndefined(search)) {
          var result = null;
          // Si les données sont de type array, on effectue un filter.
          if (lodash.isArray(storedData)) {
            result = lodash.filter(storedData, search);
          }
          // Si les données sont de type "Object", donc un non Array
          if (!lodash.isArray(storedData)) {
            result = lodash.get(storedData, search, null);
          }

          return result;
        }

        return storedData;

      },

      /**
       * Ajouter une donnée à un store existant.
       * @method add
       * @param  {string} storeName Nom du store
       * @param  {any} data      Données
       */

      add: function (storeName, data) {
        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        // Récupération du store.
        var store = this.get(storeName);
        // Si le store est vide, on le crée.
        if (store === null) {
          return this.set(storeName, _data);
        }

        // On merge les données.
        var newData = angular.merge(store, _data);
        // On met à jour notre store.
        this.set(storeName, newData);

        return true;
      },

      /**
       * Modification d'un enregistrement
       * @method update
       * @param  {string} storeName
       * @param  {any} data
       * @param  {any} remoteKey Clé permettant de lié l'enregistrement.
       * @return {bool}
       */

      update: function (storeName, data, remoteKey) {
        // remote key update.
        remoteKey = lodash.isUndefined(remoteKey) ? "id" : remoteKey;
        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        // Récupération du store.
        var store = this.get(storeName);
        // Si le store est vide, on le crée.
        if (store === null) {
          return this.set(storeName, _data);
        }

        // On recherche dans le store l'enregistrement lié.
        var search = {};
        search[remoteKey] = _data[remoteKey];
        var recordIndex = lodash.findIndex(store, search);

        // Si l'index est inconnu.
        if (recordIndex === -1) {
          return $log.error("Le store " + storeName + " ne contient pas d'enregistrement avec " + remoteKey + " est égal à " + _data[remoteKey]);
        }

        // on met à jour l'index.
        store[recordIndex] = _data;
        // On met à jour notre store.
        this.set(storeName, store);

        return true;
      }

    };

  }


})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .provider('StoreConfiguration', StoreConfiguration);

  /**
   * Provider Store.
   */


  function StoreConfiguration() {

    /**
     * Type de storage possible.
     * @type {Array}
     */

    var typeOfStorage = ['sessionStorage', 'localStorage'];

    /**
     * Default storage.
     * 'sessionStorage' ou 'localStorage';
     * @type {String}
     */

    var storage = 'sessionStorage';

    /**
     * Définir le type de store
     * @method type
     * @param  {string}         type
     */

    this.setType = function (type) {

      if (typeOfStorage.indexOf(type) === -1) {
        throw new Error("Ce type de store n'existe pas. 'sessionStorage' & 'localStorage' sont des valeurs possibles.")
      }

      storage = type;
    }

    /**
     * @method $get
     */

    this.$get = function () {
      return {
        getType: function () {
          return storage;
        }
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .factory('ChartService', ChartService);

  function ChartService($q, $http, lodash, API) {

    return {

      /**
       * Récupération du jeu de données pour le graphique.
       * @method getDataset
       */

      getDataset: function (params) {

        var resources = params.resourceId;
        var survey = params.surveyId;

        var defer = $q.defer();
        var request = $http({
          url: API + '/dataset',
          method: 'GET',
          params: {
            'resources': resources,
            'survey': survey,
          }
        })

        request
          .then(
            function success(responseSuccess) {
              // Store Token
              if (responseSuccess.status === 200) {
                var data = responseSuccess.data;
                // resolve
                defer.resolve(data);
              }

            },
            function fail() {
              defer.reject();
            })

        return defer.promise;

      },

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .controller('ChartController', ChartController);

  /** @ngInject */
  function ChartController(lodash, moment, survey, resource, dataset) {
    var vm = this;

    vm.resource = resource;
    vm.survey = survey;

    /**
     * Radar Charts options
     * @type {Object}
     */

    vm.options = {
      layout: {
        padding: 0,
        margin: 0,
      },
      legend: {
        display: false,
        position: "bottom",
        labels: {
          fontSize: 14,
        }
      },
      maintainAspectRatio: true,
      scale: {
        ticks: {
          beginAtZero: true,
          max: 3
        },
        beforeFit: function (scale) {
          if (scale.chart.config.data.labels.length === 3) {
            var pointLabelFontSize = Chart.helpers.getValueOrDefault(scale.options.pointLabels.fontSize, Chart.defaults.global.defaultFontSize);
            scale.height *= (2 / 1.5)
            scale.height -= pointLabelFontSize;
          }
        },
        afterFit: function (scale) {
          if (scale.chart.config.data.labels.length === 3) {
            var pointLabelFontSize = Chart.helpers.getValueOrDefault(scale.options.pointLabels.fontSize, Chart.defaults.global.defaultFontSize);
            scale.height += pointLabelFontSize;
            scale.height /= (2 / 1.5);
          }
        }
      }
    }

    // Labels
    vm.labels = dataset.labels;
    // ajout d'un array à data.
    vm.data = [dataset.data];
    // Legend
    vm.series = dataset.series;


  }
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController($state, $stateParams, UserService, lodash) {
    var vm = this;

    /**
     * Credentials.
     * @type {Object}
     */

    vm.credentials = {
      username: "",
      instance: "",
      password: "",
    }

    /**
     * Informations de logins.
     * @type {Object}
     */

    vm.loginRequest = {
      requesting: false,
      error: false,
    }

    // Fusion depuis le mode guest.
    if (lodash.get($stateParams, 'instance') || lodash.get($stateParams, 'username')) {
      vm.credentials = angular.merge(vm.credentials, $stateParams);
    }


    /**
     * Déclencheur de l'évènement submit
     * @method login
     * @return {}
     */

    vm.login = function () {

      vm.loginRequest.requesting = true;
      vm.loginRequest.error = false;

      UserService
        .auth(vm.credentials)
        .then(function () {
          // Success
          return $state.go('app.survey');
        }, function (responseError) {
          vm.loginRequest.error = responseError;
          // Failure.
        })
        .finally(function () {
          vm.loginRequest.requesting = false;
        })

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .factory('ApplyService', ApplyService);

  function ApplyService($q, $http, lodash, SurveyService, StoreService, API) {
    /**
     * Type de question.
     * @type {object}
     */

    var _QUESTION_TYPE = {
      "radio": "radio",
    };

    return {

      /**
       * Cette méthode s'occupe d'analyser les questions du survey.
       * En fonction du type de question, on définit "format" de réponse.
       * @method _parsingQuestions
       * @param  {array}          questions          Questions
       * @param  {object}         resource           Ce dernier contient déjà peut-être des réponses en cours.
       * @return {[type]}
       */

      _parsingQuestions: function (questions, resource) {
        var self = this;
        // Boucle sur les questions.
        lodash.forEach(questions, function (question) {
          // Si on est sur une question de type radio.
          // On boucle sur les réponses afin d'affecter une propriété "_checked = false."
          if (question.type === _QUESTION_TYPE.radio) {
            self._parsingResponses(question, resource, _QUESTION_TYPE.radio);
          }
        });

        return questions;
      },

      /**
       * Cette méthode s'occupe d'analyser les réponses.
       * En premier lieu, elle récupère une réponse précédent de l'utilisateur au survey actuellement consulté.
       * En deuxième lieu, et en fonction du type de question, elle effectue un traitement sur la réponse.
       * @method _parsingResponses
       * @param  {object}          question      Question.
       * @param  {object}          resource      ressource.
       */

      _parsingResponses: function (question, resource, typeOfQuesion) {

        var hasResourceResponse = this._hasResourceResponse(question, resource);

        // S'il y a une réponse à cette question, on considère qu'on a répondu à la question.
        if (hasResourceResponse) {
          question._done = true;
        }

        // SI la question a l'option "commentaire".
        if (question.comment && hasResourceResponse) {
          // On ajoute le commentaire s'il y en a un
          question._comment = hasResourceResponse.comment;
        }

        if (typeOfQuesion === _QUESTION_TYPE.radio) {
          // boucle sur les réponses.
          lodash.forEach(question.responses, function (response) {
            // Add checked property = false
            response._checked = false;
            // Si la question a une réponse, on met en checked true la réponse donnée précédemment.
            if (hasResourceResponse && hasResourceResponse.value == response.value) {
              response._checked = true;
            }
          });
        }

      },

      /**
       * Cette méthode cherche une réponse déjà donnée à une question.
       * @method _hasResourceResponse
       * @param  {object}                        question
       * @param  {object}                        resource
       * @return {array}
       */

      _hasResourceResponse: function (question, resource) {

        // Si la ressource ne possède pas de réponses.
        if (lodash.isEmpty(resource.responses)) {
          return null;
        }

        var responseOfQuestion = null;
        // Récupération de la callback variable de la question.
        var callbackVar = this.getCallbackVariableOfQuestion(question);
        // Dans l'objet de la resource, on retrouve un clé "responses".
        //FIXME : ONLY UNIQUE MODE.
        // Cette clé est constitué d'un array qui peut contenir les différentes réponses déjà donnée au survey.
        var resourceResponse = lodash.head(resource.responses);
        // On regarde dans la clé "response"
        // C'est dans cette clé que se trouve le json avec les réponses du survey
        var response = lodash.get(resourceResponse, 'response', null);
        // Convert to json. Securité.
        if (lodash.isString(response)) {
          response = angular.fromJson(response);
        }

        // Si réponse déja donnée.
        if (response) {
          // On recherche la réponse à la question, en fonction de la callback variable.
          responseOfQuestion = lodash.find(response, {
            "ref": callbackVar
          });
        }

        return responseOfQuestion;
      },

      /**
       * Cette méthode permet de récupérer la variable callback d'une question.
       * La variable callback définit l'index qui contient l'objet de réponse.
       * @method getCallbackVariableOfQuestion
       * @param  {object} question Question.
       * @return {string}
       */

      getCallbackVariableOfQuestion: function (question) {

        if (!lodash.isEmpty(question.callback_variable)) {
          return question.callback_variable;
        }

        return question.ref;
      },


      /**
       * Création d'une réponse unique
       * @method _createUniqueResponse
       * @param  {object}              userAnswer Reponse
       * @param  {object}              survey           Survey lié
       * @param  {object}              resource         Pending apply. Ressource à évalué
       */

      _createUniqueResponse: function (userAnswer, survey, resource) {
        var self = this;
        // on extrait la ref de la question.
        var questionRef = angular.copy(userAnswer.ref);

        var response = {
          "id": null, // je l'aurais lorsque j'aurais un retour ok de création.
          // je place la réponse dans un array car il y en aura plusieurs.
          "response": [userAnswer],
          "resource_id": resource.id,
          // On envoie la ref de la dernière question.
          "last_ref": questionRef,
        }

        $http({
          url: API + '/response',
          method: 'POST',
          data: response,
        }).then(
          function success(responseSuccess) {
            // ajout de la réponse à la resource.
            resource.responses.push(responseSuccess.data);
            // maj resource.
            // self._updateResource(survey, resource);

            SurveyService.updateSurvey(survey, resource);

          },
          function fail() {

          })

      },

      /**
       * Mise à jour d'une réponse
       * @method _updateUniqueResponse
       * @param  {object}              userResponse
       */

      _updateUniqueResponse: function (userAnswer, survey, resource) {

        var self = this;
        // on extrait la ref de la question.
        var questionRef = angular.copy(userAnswer.ref);
        // On extrait la première réponse (étant donné qu'il y en q'une seule en mode unique.)
        var resourceResponse = lodash.head(resource.responses)
        // maj last ref.
        resourceResponse.last_ref = questionRef;
        // On extrait la réponse sous au survey.
        var responseForSurvey = lodash.get(resourceResponse, 'response', []);
        // Json décode.
        if (lodash.isString(responseForSurvey)) {
          responseForSurvey = angular.fromJson(responseForSurvey);
        }
        // on s'assure que la réponse n'a pas déjà été donnée via sa réf.
        var hasRefIndex = lodash.findIndex(responseForSurvey, {
          "ref": userAnswer.ref
        });
        // Si cette réponse existe, on update.
        if (hasRefIndex !== -1) {
          responseForSurvey[hasRefIndex] = angular.merge(responseForSurvey[hasRefIndex], userAnswer);
        } else {
          //Sinon On pousse la nouvelle réponse.
          responseForSurvey.push(userAnswer);
        }

        $http({
          url: API + '/response/' + resourceResponse.id,
          method: 'PATCH',
          data: {
            "response": resourceResponse.response,
            // On envoie la ref de la dernière question.
            "last_ref": questionRef,
          }
        }).then(
          function success() {
            // On met à jour la ressource avec les nouvelles réposnes.
            resourceResponse.response = responseForSurvey;
            // maj resource.
            SurveyService.updateSurvey(survey, resource);
          },
          function fail() {

          })
      },

      /**
       * Cette méthode "construit" le formulaire d'évaluation pour un survey.
       * @method build
       * @param  {int} surveyId Id du survey
       * @param  {int} resourceId  Id de personne qui doit être evalué
       * @return {any}
       */

      build: function (surveyId, resourceId) {
        var survey = angular.copy(SurveyService.getSurveyFromId(surveyId));
        var defer = $q.defer();

        // Si le survey n'existe pas.
        // Mauvais id par exemple
        if (!survey) {
          return $q.reject();
        }

        // ressource.
        var resource = lodash.find(survey.resources, {
          "id": lodash.toInteger(resourceId)
        })

        // Analyse des questions.
        var questions = this._parsingQuestions(lodash.get(survey, 'questions'), resource);

        // Evaluation en cours.
        var parsingSurvey = {
          'questions': questions,
          'categories': lodash.get(survey, 'categories'),
          'survey': survey,
          'resource': resource,
        };

        defer.resolve(parsingSurvey)

        return defer.promise;
      },

      /**
       * Cette méthode se charge de sauvegarder une réponse.
       * Elle crée l'objet response et détermine si c'est une nouvelle réponse ou un update.
       * @method saveAnswer
       * @param  {object}   question
       * @param  {object}   answer
       * @return {bool}
       */

      saveAnswer: function (question, answer, survey, resource) {

        var self = this;

        var userAnswer = {
          "ref": self.getCallbackVariableOfQuestion(question),
          // Réponse de la valeur de la réponse.
          "value": lodash.get(answer, 'value', null),
          // Récupération du score de la réponse (s'il y en a un)
          "score": lodash.get(answer, 'score', null),
          // Commentaire.
          "comment": lodash.get(question, '_comment', null),
        }

        // TODO: définir si une campagne a un mode multiple ou mode unique
        //NB : ONLY UNIQUE MODE FOR MOMENT.
        // si il n'y a pas de réponses, on la crée.
        if (resource.responses.length === 0) {
          return this._createUniqueResponse(userAnswer, survey, resource);
        }

        // On save sur le serveur.
        this._updateUniqueResponse(userAnswer, survey, resource);

        return true;
      },

      /**
       * Sauvegarder le commentaire à une question.
       * Cette méthode a raison d'être car un commentaire peut se rajouter à tout moment.
       * Cependant, elle éxecute un update de la réponse en passant un commentaire.
       * @method saveAnswerComment
       * @param  {object}          question
       * @param  {object}          survey
       * @param  {object}          resource
       */

      saveAnswerComment: function (question, survey, resource) {
        var self = this;

        var userAnswer = {
          "ref": self.getCallbackVariableOfQuestion(question),
          // Commentaire.
          "comment": lodash.get(question, '_comment', null),
        }
        // FOR MOMENT.
        //NB : only unique mode
        return this._updateUniqueResponse(userAnswer, survey, resource);
      },


      /**
       * Envoyer une évaluation.
       * @method sendApply
       * @param  {object}  resource
       * @return {promise}
       */

      sendApply: function (resource, survey) {

        var self = this;
        var defer = $q.defer();

        $http({
          url: API + '/resource/apply/' + resource.id,
          method: 'POST',
        }).then(
          function success() {
            //FIXME : ONLY FOR UNIQUE MODE.
            // On extrait la première réponse (étant donné qu'il y en q'uune seule)
            var resourceResponse = lodash.head(resource.responses)
            // on s'assure que la réponse n'a pas déjà été donnée via sa réf.
            resourceResponse.state = "done";
            // maj resource.
            // self._updateResource(survey, resource);

            defer.resolve();
          },
          function fail() {

          })

        return defer.promise;

      },



    }

  }


})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .controller('ApplyController', ApplyController);

  function ApplyController($scope, $timeout, apply, $state, $document, ApplyService, toastr, lodash) {

    var vm = this;

    var questions = angular.copy(apply.questions);
    var categories = angular.copy(apply.categories);

    /**
     * Données relatives au survey.
     * @type {Object}
     */

    vm.survey = apply.survey;


    /**
     * Données relatives au client
     * resource.
     * Client sur lequel on réalise l'évaluation.
     * @type {[type]}
     */

    vm.resource = apply.resource;
    console.log(vm.resource);
    /**
     * Afficher les questions auxquelles on a déjà répondu.
     * @type {Boolean}
     */

    vm.showDoneQuestion = false;

    /**
     * Gestion des categories
     * @type {Object}
     */

    vm.categories = {
      active: null,
      enabled: lodash.isEmpty(categories) ? false : true,
      data: categories,
    };

    /**
     * Statistiques.
     * @type {Object}
     */

    vm.statistics = {
      numberOfQuestions: 0,
      numberOfQuestionsRequired: 0,
      numberOfQuestionsDone: 0,
      numberOfQuestionsDonePercentage: 0,
    }

    // Si il y a des categories
    if (!lodash.isEmpty(vm.categories.data)) {
      // on rends la première active
      // var firstElement = lodash.head(vm.categories.data);
      // vm.categories.active = lodash.get(firstElement, 'id', null);
      vm.categories.active = 'all';
    }

    /**
     * Cette méthode rends active la catégorie sélectionne.
     * Si il y a des catégories.
     * @method setActivePills
     * @param  {any}       category
     */

    vm.setActivePills = function (category) {

      if (category === 'all') {
        return vm.categories.active = 'all';
      }

      vm.categories.active = category.id;
    }

    /**
     * Récupérer les questions en fonction d'une catégorie.
     * Si il y a des catégories bien entendu
     * @method getQuestionsFromCategory
     * @param  {int}  id
     * @return {array}
     */

    var getQuestionsFromCategory = function (id) {

      if (lodash.isNull(id) || id === 'all') {
        return questions;
      }

      return lodash.filter(questions, {
        "category": id,
      })
    }

    /**
     * Cette méthode retourne le nombre de questions en fonction d'une catégorie.
     * @method getNumberOfQuestionsFromCategory
     * @param  {int}  id
     * @return {}
     */

    var getNumberOfQuestionsFromCategory = function (id) {

      if (lodash.isNull(id) || id === 'all') {
        return questions.length;
      }

      return lodash.filter(questions, {
        "category": id,
      }).length;
    }

    /**
     * Calcul de la progression en fonction de la category (oupas)
     * @method progressionOfSurveyFromCategory
     * @param  {int}  id
     */

    var progressionOfSurveyFromCategory = function (id) {

      if (lodash.isNull(id) || id === 'all') {
        // Nbr of Question Done.
        vm.statistics.numberOfQuestionsDone = lodash.filter(vm.questions, {
          "_done": true,
        }).length

        // Nbr of question done percentange.

      } else {
        // Nbr of Question Done.
        vm.statistics.numberOfQuestionsDone = lodash.filter(vm.questions, {
          "_done": true,
          "category": id,
        }).length

      }
      // percentage
      if (vm.statistics.numberOfQuestions > 0) {
        vm.statistics.numberOfQuestionsDonePercentage = ((vm.statistics.numberOfQuestionsDone / vm.statistics.numberOfQuestions) * 100).toFixed(0);
      }
    }

    /**
     * On observe le changement de catégorie pour y afficher les quesitons liés.
     * @type {[type]}
     */

    $scope.$watch('$ctrl.categories.active', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      vm.questions = getQuestionsFromCategory(newVal);
      vm.statistics.numberOfQuestions = getNumberOfQuestionsFromCategory(newVal);

      progressionOfSurveyFromCategory(newVal);

      $document.scrollTop(0, 500);
    })

    /**
     * On observe quand on coche "Afficher les questions auxquelles j'ai répondu"
     */

    $scope.$watch('$ctrl.showDoneQuestion', function (newVal, oldVal) {

      if (newVal === oldVal) {
        return;
      }
      // Remote top.
      if (newVal === true) {
        $document.scrollTop(0, 500);
      }
    })

    /**
     * Quand une question a été checkée.
     * @method whenQuestionDone
     * @return {}
     */

    vm.whenQuestionDone = function () {
      progressionOfSurveyFromCategory(vm.categories.active);
    }

    /**
     * On récupère les questions ne fonction de la categories.
     */

    vm.questions = getQuestionsFromCategory(vm.categories.active);

    /**
     * On récupère le nbr de questions en fonction des catégories.
     */

    vm.statistics.numberOfQuestions = getNumberOfQuestionsFromCategory(vm.categories.active);

    /**
     * Nombre de questions requises.
     * @type {int}
     */

    vm.statistics.numberOfQuestionsRequired = lodash.filter(questions, {
      "required": true
    }).length;

    progressionOfSurveyFromCategory(vm.categories.active);

    /**
     * Filtre.
     * Ce filtre affiche les questions auxquelles on a répondu.
     * @method filterDoneQuestion
     * @param  {object}     q
     * @return {object}
     */

    vm.filterDoneQuestion = function (q) {

      if (vm.showDoneQuestion) {
        return q._done === true;
      }

      return q;
    }

    /**
     * Send apply
     * @method sendApply
     * @return {[type]}
     */

    vm.sendApply = function () {
      ApplyService
        .sendApply(vm.resource, vm.survey)
        .then(function () {
          // show toast
          toastr.success('Évaluation envoyée avec succès !');
          // redirect to survey page.
          $state.go('app.survey');
        });
    }

    $scope.$on('$viewContentLoaded', function () {
      $timeout(function () {
        //FIXME : MODE UNIQUE / MULTIPLE
        var lastResponse = lodash.head(apply.resource.responses);
        if (!lastResponse || lastResponse.state === 'done') {
          return;
        }

        angular.element($document).ready(function () {
          var lastRef = lastResponse.last_ref;
          var lastElement = angular.element(document.getElementById(lastRef));
          var lastElementRect = lastElement[0].getBoundingClientRect();

          $document.scrollTop(lastElementRect.top, 750);
        });
      }, 0);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {}

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    // $stateProvider
    //   .state('app', {
    //     url: '/',
    //     abstract: true,
    //   });

    /**
     * Authentificaiton route
     */

    $stateProvider
      .state('auth', {
        url: '/auth',
        params: {
          "instance": null,
          "username": null,
          "hash": null,
        },
        controller: 'AuthController as auth',
        templateUrl: 'app/auth/auth.html',
      });


    /**
     * Route invité
     **/

    $stateProvider
      .state('guest', {
        url: '/?instance&username&hash',
        resolve: {
          before: function ($stateParams, $timeout, $state) {
            $timeout(function () {
              $state.go('auth', $stateParams);
            });
          }
        }
      });

    /**
     * Page où l'on retrouve les campagnes (survey) de l'user/instance
     */

    $stateProvider
      .state('app', {
        url: '/dashboard',
        template: '<div ui-view></div>',
        resolve: {
          hasSession: function ($q, $timeout, $state, UserService) {

            if (!UserService.hasSession()) {
              $timeout(function () {
                $state.go('auth')
              });

              return $q.reject();
            }

            return $q.resolve();
          }
        }
      });

    $stateProvider
      .state('app.survey', {
        url: '/grilles-evaluations',
        controller: 'SurveyController as $ctrl',
        templateUrl: 'app/survey/survey.html',
        resolve: {
          surveys: function (SurveyService) {
            return SurveyService.getSurveys();
          }
        }
      });

    /**
     * Page où l'on retrouve le survey en fonction d'une personne.
     */

    $stateProvider
      .state('app.apply', {
        url: '/evaluation/{surveyId}/{resourceId}',
        controller: 'ApplyController as $ctrl',
        templateUrl: 'app/apply/apply.html',
        resolve: {
          surveys: function (SurveyService) {
            return SurveyService.getSurveys();
          },
          apply: function (surveys, $stateParams, ApplyService) {
            return ApplyService.build($stateParams.surveyId, $stateParams.resourceId);
          }
        }
      });

    /**
     * Page où l'on retrouve le survey en fonction d'une personne.
     */

    $stateProvider
      .state('app.chart', {
        url: '/chart/{surveyId}/{resourceId}',
        params: {
          "resourceId": null,
          "surveyId": null,
        },
        controller: 'ChartController as $ctrl',
        templateUrl: 'app/chart/chart.template.html',
        resolve: {
          surveys: function (SurveyService) {
            return SurveyService.getSurveys();
          },
          resource: function (surveys, $stateParams, lodash, SurveyService) {
            var survey = SurveyService.getSurveyFromId($stateParams.surveyId);
            var resource = lodash.find(survey.resources, {
              "id": parseInt($stateParams.resourceId)
            });

            return resource;
          },
          survey: function ($stateParams, SurveyService) {
            return SurveyService.getSurveyFromId($stateParams.surveyId);
          },
          dataset: function ($stateParams, ChartService) {
            return ChartService.getDataset($stateParams);
          },
        }
      });


    $urlRouterProvider.otherwise('/auth');
  }

})();

(function() {
  'use strict';

  angular
    .module('gunta')
    .constant("API", "https://apps.snv.io/gunta/api/client") 
.constant("BASE_HREF", "/gunta/") ;

})();

/* global moment:false */
(function () {
  'use strict';

  angular
    .module('gunta')
    .constant('moment', moment)
    .constant('APP_STORAGE_PREFIX', 'snv_survey')

})();

(function () {
  'use strict';

  angular
    .module('gunta')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, StoreConfigurationProvider, $httpProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 5000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = false;
    toastrConfig.progressBar = true;

    // HTML5mode
    $locationProvider.html5Mode(true);

    // Charts
    // ChartJsProvider.setOptions({
    //   chartColors: ['#2196F3', '#FF9800', '#FFEB3B', '#4CAF50', '#795548', '#F44336', '#009688']
    // });

    // Intercepteur
    $httpProvider.interceptors.push(function ($injector) {
      return {
        request: function (req) {
          var UserService = $injector.get('UserService');
          // On place le token d'identification dans chaque requête, pour autant qu'il y en ait un.
          if (UserService.getToken()) {
            req.headers.Authorization = UserService.getToken();
          }
          return req;
        }
      };
    });
  }

})();

angular.module("gunta").run(["$templateCache", function($templateCache) {$templateCache.put("app/apply/apply.html","<navbar resource=$ctrl.resource survey=$ctrl.survey send-apply=$ctrl.sendApply() send-apply-button-disabled=\"$ctrl.statistics.numberOfQuestionsDone == $ctrl.statistics.numberOfQuestions\"></navbar><div class=container-apply ng-cloak><!-- ONLY FOR PRINT. --><div class=print-usg><div class=image><img ng-src-404=assets/images/profile.png ng-src={{$ctrl.resource.profile_image_url}}></div><div class=resource><b>{{$ctrl.resource.name}}</b><br><span ng-bind-html=\"$ctrl.resource.description | nl2br\"></span></div><div class=pull-right><img class=logo-company src=assets/images/logo.png alt=\"\"> <span class=survey-name>{{$ctrl.survey.name}}</span></div></div><!-- Container rubriques. --><ul class=\"nav nav-pills\" ng-if=$ctrl.categories.enabled><li class=all ng-click=\"$ctrl.setActivePills(\'all\')\" ng-class=\"{\'active\' : $ctrl.categories.active === \'all\'}\"><a>Toutes les rubriques</a></li><li ng-repeat=\"category in $ctrl.categories.data\" ng-click=$ctrl.setActivePills(category) ng-class=\"{\'active\' : $ctrl.categories.active === category.id}\"><a>{{category.ref}} {{category.name}}</a></li></ul><div class=container><!-- Questions --><div ng-repeat=\"question in $ctrl.questions | filter:$ctrl.filterDoneQuestion\"><survey-question question=question resource=$ctrl.resource survey=$ctrl.survey when-question-done=$ctrl.whenQuestionDone()></survey-question></div></div></div><!-- /container-$ctrl --><!-- Footer --><footer class=\"navbar navbar-default navbar-fixed-bottom navbar-bottom-apply\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-disabled=\"$ctrl.statistics.numberOfQuestionsDone === 0\" ng-model=$ctrl.showDoneQuestion> Afficher mes réponses <span ng-if=\"$ctrl.statistics.numberOfQuestionsDone > 0\" class=badge>{{$ctrl.statistics.numberOfQuestionsDone}}</span></label></div></div></div><div class=row><div class=col-xs-12><div class=\"progress progress-striped\"><div class=\"progress-bar progress-bar-success active\" style=\"width: {{$ctrl.statistics.numberOfQuestionsDonePercentage}}%\"></div></div><div class=progress-info>Progression : {{$ctrl.statistics.numberOfQuestionsDonePercentage}}% ({{$ctrl.statistics.numberOfQuestionsDone}}/{{$ctrl.statistics.numberOfQuestions}})</div></div></div></div></footer><back-top button-theme=light><i class=\"fa fa-arrow-up\"></i></back-top>");
$templateCache.put("app/auth/auth.html","<div class=auth-background><div class=container-fluid><div class=row><div class=\"col-xs-12 col-md-4 col-md-offset-4\"><form class=login-form name=loginForm ng-submit=auth.login()><!-- Form group --><div class=form-group><!-- <label for=\"username\">Nom d\'utilisateur</label> --> <input type=text id=username name=username ng-model=auth.credentials.username placeholder=\"Nom d\'utilisateur\" required autofocus></div><!-- Form group --><div class=form-group><!-- <label for=\"instance\">Instance</label> --> <input type=text id=instance name=instance ng-model=auth.credentials.instance placeholder=Instance required></div><!-- Form group --><div class=form-group><!-- <label for=\"password\">Mot de passe</label> --> <input type=password id=password name=password ng-model=auth.credentials.password placeholder=\"Mot de passe\" required></div><div ng-if=auth.loginRequest.error><p class=\"text-danger text-center\">{{auth.loginRequest.error}}</p></div><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=\"loginForm.$invalid || auth.loginRequest.requesting\"><span ng-if=!auth.loginRequest.requesting>Connexion</span> <span ng-if=auth.loginRequest.requesting>Connexion en cours...</span></button></form></div></div></div></div>");
$templateCache.put("app/chart/chart.template.html","<navbar resource=$ctrl.resource survey=$ctrl.survey></navbar><div class=\"container container-chart\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-offset-2\"><div><canvas id=radar class=\"chart chart-radar\" chart-labels=$ctrl.labels chart-series=$ctrl.series chart-data=$ctrl.data chart-options=$ctrl.options></canvas><div class=ref ng-repeat=\"category in $ctrl.survey.categories\"><b>{{category.ref}}</b> = {{category.name}}<br></div></div></div></div>");
$templateCache.put("app/survey/survey.html","<!-- Static navbar --><nav class=\"navbar navbar-default survey-navbar\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand>Grilles d\'évaluations</a></div><div id=navbar uib-collapse=navCollapsed class=\"navbar-collapse collapse\"><!-- navbar collapse. --><ul class=\"nav navbar-nav\" ng-if=!navCollapsed><li ng-repeat=\"survey in $ctrl.surveys\"><a ng-click=$ctrl.selectSurvey(survey);>{{survey.name}}</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li class=text-center><button type=button class=\"btn btn-danger navbar-btn\" ng-click=$ctrl.doLogout()><i class=\"fa fa-power-off\"></i> Se déconnecter</button></li></ul></div><!--/.nav-collapse --></div><!--/.container-fluid --></nav><div class=\"container-fluid survey-container\"><!-- Surveys --><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 master-column hidden-xs\"><div class=row><div class=col-xs-12><h2 class=master-title><span class=number>1</span> Sélectionnez une évaluation</h2></div></div><div class=\"row top20\"><div ng-repeat=\"survey in $ctrl.surveys\"><div class=col-xs-12><div class=\"panel panel-survey\" ng-class=\"{\'panel-primary\' : !survey._done, \'panel-success\' :survey._done}\"><div class=panel-heading><h3 class=panel-title><i class=\"fa fa-check\" ng-if=survey._done></i> {{survey.name}}</h3></div><!-- body --><div class=panel-body><div class=row><img class=survey-img ng-src={{survey.image_url}}></div><div class=row><div class=col-xs-12><div class=\"progress progress-striped active\"><div class=\"progress-bar progress-bar-success\" style=\"width: {{survey._progression}}%\"></div></div></div></div></div><!-- footer --><div class=panel-footer><div class=text-right><!-- More options --><div class=btn-group uib-dropdown ng-if=survey._hasOneSurveyFinished><a class=\"btn btn-default\" uib-dropdown-toggle tooltip-placement=top tooltip-append-to-body=true uib-tooltip=\"Afficher les fonctionnalités\"><i class=\"fa fa-bars\"></i></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem><a href=\"\" ng-click=$ctrl.doChartForSurvey(survey)><i class=\"fa fa-line-chart\"></i> Afficher le graphique</a></li></ul></div><!-- Evaluer --> <a ng-click=$ctrl.selectSurvey(survey); class=\"btn btn-primary\">Evaluer <i class=\"fa fa-arrow-right\"></i></a></div></div></div><!-- end panel --></div></div></div></div><!-- Pending surveys --><div class=\"col-xs-12 col-sm-6 col-md-8 col-lg-8 master-column\"><!-- resources --><div ng-if=\"$ctrl.resources.length > 0\" class=pending-apply-container><div class=row><!-- Evaluez --><div class=col-xs-12><h2 class=master-title><span class=number>2</span> Évaluez ({{$ctrl.parsedResources.length}})<!-- Buttons toolbar --><div class=pull-right><!-- Pagination --><!-- <div class=\"text-center\"> --><ul uib-pagination force-ellipses=true previous-text=\"&lt; Précédent\" next-text=\"Suivant &gt;\" total-items=$ctrl.resourcesPagination.total ng-model=$ctrl.resourcesPagination.currentPage max-size=3 class=\"pagination-sm pagination\" num-pages=$ctrl.resourcesPagination.numberOfPages></ul><!-- </div> --><!-- End paginate --><div class=btn-group><!-- show pending resource survey --> <a class=\"btn btn-icon\" ng-class=\"{\'btn-warning\' : $ctrl.search.showPendingSurveyForResource, \'btn-default\' : !$ctrl.search.showPendingSurveyForResource }\" ng-click=\"$ctrl.search.showPendingSurveyForResource = !$ctrl.search.showPendingSurveyForResource; $ctrl.search.showDoneSurveyForResource = false\" tooltip-placement=bottom-left tooltip-append-to-body=true uib-tooltip=\"Afficher les évaluations en cours\"><i class=\"fa fa-clock-o\"></i> </a><!-- show done resource survey --> <a class=\"btn btn-icon\" ng-class=\"{\'btn-success\' : $ctrl.search.showDoneSurveyForResource, \'btn-default\' : !$ctrl.search.showDoneSurveyForResource }\" ng-click=\"$ctrl.search.showDoneSurveyForResource = !$ctrl.search.showDoneSurveyForResource; $ctrl.search.showPendingSurveyForResource = false\" tooltip-placement=bottom-right tooltip-append-to-body=true uib-tooltip=\"Afficher les évaluations envoyées\"><i class=\"fa fa-check\"></i></a></div><!-- search --> <a class=\"btn btn-default btn-icon\" ng-class=\"{\'active\' : $ctrl.search.enabled}\" ng-click=\"$ctrl.search.enabled = !$ctrl.search.enabled; $ctrl.search.value = \'\'\" tooltip-placement=bottom tooltip-append-to-body=true uib-tooltip=\"Effectuer une recherche\"><i class=\"fa fa-search\"></i></a></div></h2></div></div><!-- search --><div class=row ng-if=$ctrl.search.enabled><div class=col-xs-12><!-- search form --><div class=form-group><div class=input-group><span class=input-group-addon><i class=\"fa fa-search\"></i> </span><input type=text class=form-control placeholder=Recherche... autofocus ng-model=$ctrl.search.value></div></div></div></div><!-- resources --><div class=\"row top20\"><!--  resources ng -repeat --><div ng-repeat=\"resource in $ctrl.parsedResources | limitTo: $ctrl.resourcesPagination.itemsPerPage : ($ctrl.resourcesPagination.currentPage -1) * $ctrl.resourcesPagination.itemsPerPage\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-survey\" ng-class=\"{\'panel-primary\' : !resource._responseState, \'panel-success\' : resource._responseState === \'done\', \'panel-warning\' : resource._responseState === \'pending\'}\"><div class=panel-heading><h3 class=panel-title><i class=\"fa fa-check\" ng-if=\"resource._responseState === \'done\'\"></i> <i class=\"fa fa-clock-o\" ng-if=\"resource._responseState === \'pending\'\"></i> {{resource.name}}</h3></div><!-- body --><div class=panel-body><div class=row><img class=profile-img ng-src-404=assets/images/profile.png ng-src={{resource.profile_image_url}}><p class=description ng-bind-html=\"resource.description | nl2br\"></p></div><div class=row><div class=col-xs-12><div class=\"progress progress-striped active\"><div class=\"progress-bar progress-bar-success\" style=\"width: {{resource._progression}}%\"></div></div></div></div></div><!-- footer --><div class=panel-footer><div class=text-right><!-- More options --><div class=btn-group uib-dropdown ng-if=\"resource._responseState === \'done\'\"><a class=\"btn btn-default\" uib-dropdown-toggle tooltip-placement=top tooltip-append-to-body=true uib-tooltip=\"Afficher les fonctionnalités\"><i class=\"fa fa-bars\"></i></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem><a href=\"\" ng-click=$ctrl.doChartForResource(resource)><i class=\"fa fa-line-chart\"></i> Afficher le graphique</a></li></ul></div><!-- Evaluer --> <a ng-if=!resource._responseState ng-click=$ctrl.selectResource(resource) class=\"btn btn-primary\">Évaluer <i class=\"fa fa-arrow-right\"></i> </a><!-- reprendre évaluation --> <a ng-if=\"resource._responseState === \'pending\'\" ng-click=$ctrl.selectResource(resource) class=\"btn btn-warning\">Continuer l\'évaluation <i class=\"fa fa-arrow-right\"></i> </a><!-- Voir évaluation --> <a ng-if=\"resource._responseState === \'done\'\" ng-click=$ctrl.selectResource(resource) class=\"btn btn-success\">Voir l\'évaluation <i class=\"fa fa-arrow-right\"></i></a></div></div></div><!-- end panel --></div></div></div></div></div></div><!-- end container -->");
$templateCache.put("app/components/navbar/navbar.template.html","<nav class=\"navbar navbar-default navbar-fixed-top navbar-top-apply\" role=navigation><div class=container-fluid><!-- Brand and toggle get grouped for better mobile display --><div class=navbar-header><button type=button class=navbar-toggle data-toggle=collapse data-target=#navbar-brand-centered><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=\"navbar-brand navbar-brand-centered\">{{$ctrl.survey.name}}</div></div><!-- Collect the nav links, forms, and other content for toggling --><div class=\"collapse navbar-collapse\" id=navbar-brand-centered><!-- Retour aux évaluations --><div class=navbar-btn style=float:left><button class=\"btn btn-default\" ng-click=$ctrl.resumeLater()><i class=\"fa fa-arrow-left\" tooltip-placement=right tooltip-append-to-body=true uib-tooltip=\"Retour aux évaluations\" aria-hidden=true></i></button></div><ul class=\"nav navbar-nav navbar-left\" ng-if=$ctrl.resource><li class=customer><div class=image><img ng-src-404=assets/images/profile.png ng-src={{$ctrl.resource.profile_image_url}}></div><div class=resource><b>{{$ctrl.resource.name}}</b><br><span ng-bind-html=\"$ctrl.resource.description | nl2br\"></span></div></li></ul><ul class=\"nav navbar-nav navbar-right\"><li><div class=navbar-btn><div class=btn-group uib-dropdown><button class=\"btn btn-default\" ng-click=$ctrl.print()><i class=\"fa fa-print\"></i> Imprimer</button> <button type=button class=\"btn btn-default\" uib-dropdown-toggle><span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=split-button><li role=menuitem><a ng-click=$ctrl.print()><i class=\"fa fa-print\"></i>&nbsp;&nbsp;Imprimer</a></li><li role=menuitem><a ng-click=$ctrl.doChartStatistics() ng-if=\"$ctrl.resource._responseState === \'done\'\"><i class=\"fa fa-line-chart\"></i>&nbsp;&nbsp;Voir le graphique</a></li><li role=menuitem><a ng-click=$ctrl.doSurveyForResource() ng-if=\"$ctrl.resource._responseState === \'done\'\"><i class=\"fa fa-list-ol\"></i>&nbsp;&nbsp;Voir la réponse</a></li></ul></div></div></li><!-- Si on est sur une évaluation. --><li ng-if=\"(!$ctrl.resource._responseState || $ctrl.resource._responseState === \'pending\') && $ctrl.isApply\"><div class=navbar-btn><button class=\"btn btn-warning\" ng-click=$ctrl.resumeLater()><i class=\"fa fa-clock-o\"></i> Continuer plus tard</button></div></li><li ng-if=\"(!$ctrl.resource._responseState || $ctrl.resource._responseState === \'pending\') && $ctrl.isApply\"><div class=navbar-btn><button class=\"btn btn-success\" ng-disabled=\"$ctrl.sendingProgress || !$ctrl.sendApplyButtonDisabled\" ng-click=$ctrl.doSendButton()><i class=\"fa fa-paper-plane-o\"></i> <span ng-if=!$ctrl.sendingProgress>Envoyer</span> <span ng-if=$ctrl.sendingProgress>Envoi en cours...</span></button></div></li><!-- /Si on est sur une évaluation. --><!-- <li ng-if=\"$ctrl.resource._responseState === \'done\'\">\n          <div class=\"navbar-btn\">\n            <button class=\"btn btn-primary\"\n                ng-click=\"$ctrl.resumeLater()\">\n              <i class=\"fa fa-arrow-left\"></i> Retour aux évaluations\n            </button>\n          </div>\n        </li> --></ul></div><!-- /.navbar-collapse --></div><!-- /.container-fluid --></nav>");
$templateCache.put("app/components/surveyQuestion/surveyQuestion.template.html","<div id={{surveyQuestion.ref}} class=\"survey-question not-visible\" when-visible=surveyQuestion.animateElementIn when-not-visible=surveyQuestion.animateElementOut delay-percent=0.7><h1 class=name><!-- Question ref --> <span class=ref>{{surveyQuestion.question.ref}} <i class=\"fa fa-arrow-right\"></i> </span><!-- Question name --> {{surveyQuestion.question.name}}<!-- Required --> <span class=text-danger ng-if=\"surveyQuestion.question.required === true\">*</span><br><!-- HELP --> <span class=help ng-if=surveyQuestion.question.help tooltip-placement=right tooltip-class=help-tooltip uib-tooltip-html=surveyQuestion.question.help><i class=\"fa fa-question-circle survey-tooltip\"></i> Besoin d\'aide?</span></h1><div class=response><!-- Question de type radio. --><section ng-if=\"surveyQuestion.question.type === \'radio\'\"><!-- TYPE RADIO --><div class=\"type-radio row\" ng-repeat=\"answer in surveyQuestion.question.responses\"><!-- Response --><div class=button-response ng-click=surveyQuestion.doAnswerWithRadioType(answer) ng-class=\"{\'checked\' : answer._checked}\"><div class=letter>{{answer.value}}</div>{{answer.name}}</div></div></section><!-- S\'il y a une remarque / question. --><section class=comment ng-if=surveyQuestion.comment.enabled><div ng-if=\"surveyQuestion.comment.activeButton && !surveyQuestion.comment.activeForm && !surveyQuestion.question._comment\"><a class=\"btn btn-primary\" ng-click=surveyQuestion.toggleCommentForm();>Ajouter un commentaire ?</a> <a style=padding-left:10px ng-click=surveyQuestion.whenQuestionDone(true)>Non merci</a></div><!-- Comment form. --><form class=form-group ng-if=surveyQuestion.comment.activeForm><textarea autofocus msd-elastic class=form-control required ng-model=surveyQuestion.comment.value placeholder=\"Ecrivez votre commentaire ici...\">\n        </textarea><div class=button-group><button class=\"btn btn-default\" ng-click=surveyQuestion.toggleCommentForm()>Annuler</button> <button class=\"btn btn-success\" type=submit ng-disabled=\"!surveyQuestion.question._comment && !surveyQuestion.comment.value\" ng-click=surveyQuestion.addComment(surveyQuestion.comment.value)>Enregistrer le commentaire</button></div></form><blockquote ng-if=\"surveyQuestion.question._comment && !surveyQuestion.comment.activeForm \"><p class=title-comment>Commentaire <small><a class=update-comment ng-click=surveyQuestion.toggleCommentForm() ng-if=surveyQuestion.comment.canUpdate>Modifier</a></small></p><p ng-bind-html=\"surveyQuestion.question._comment | nl2br\"></p></blockquote></section></div><!-- END TYPE RADIO --></div>");}]);